export default "__VITE_ASSET__CaYSxuW4__"